class StorageUtils {
    private static appPrefix: string = 'onit_';

    public static setItem(key: string, value: string, days: number = 365): void {
        // console.log("setItem", key, document.cookie);
        let date: Date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        let expires: string = "; expires=" + date.toUTCString();

        
        let domain: string = ' domain=.onitnetwork.com;';
        if (window.location.hostname.indexOf('.onitnetwork.com') == -1) {
            domain = ' domain=onitdev;';
            document.cookie = this.appPrefix + key + "=" + encodeURIComponent(value) + expires + "; path=/";
        } else {
            document.cookie = this.appPrefix + key + "=" + encodeURIComponent(value) + expires + "; " + domain + "path=/";
        }

        // console.log("setItem 1", key, document.cookie);
    }

    public static getItem(key: string): string {
        let nameEQ: string = this.appPrefix + key + "=";
        let ca: string[] = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c: string = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }

        return null;
    }

    public static clear() {
        this.setItem('user', '', -1);
        this.setItem('token', '', -1);
        this.setItem('verifyOTP', '', -1);
        this.setItem('instance', '');
    }
}

export default StorageUtils;


// WEBPACK FOOTER //
// ./src/server/utils/storage-utils.ts